import React from 'react';
import { Navigate } from 'react-router-dom';
import { MainLayout } from '@/components/layout/MainLayout';
import { ProjectDeveloperDashboard as ProjectDeveloperDashboardComponent } from '@/components/dashboard/ProjectDeveloperDashboard';
import { useAuth } from '@/components/AuthProvider';

const ProjectDeveloperDashboard = () => {
  const { user, profile } = useAuth();

  // Redirect to home if not authenticated
  if (!user) {
    return <Navigate to="/" replace />;
  }

  // Redirect to general dashboard if not a project developer
  if (profile?.user_type !== 'project_developer') {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <MainLayout>
      <ProjectDeveloperDashboardComponent user={user} profile={profile} />
    </MainLayout>
  );
};

export default ProjectDeveloperDashboard;